import { filter, find } from 'lodash';
import React, { useContext, useMemo } from 'react';
import { useQuery } from 'react-query';
import { Loader, Panel } from 'rsuite';
import { fetchCategoriesList } from '../api';
import { useLocation } from '../hooks/useLocation';
import { EquipmentContext } from '../utils/scope';
import { Categories } from './Categories';
import { CategoriesWrap } from './CategoriesWrap';

const getCatCount = (cat, all) =>
  cat.count +
  all.filter((c) => c.parent === cat.term_id).reduce((a, b) => a + getCatCount(b, all), 0);

const fillCounts = (cats, all) => {
  return cats.map((cat) => {
    const count_with_sub = getCatCount(cat, all);
    return { ...cat, count_with_sub };
  });
};

export const CategoriesPanel = () => {
  const scope = useContext(EquipmentContext);
  const { status, data, error } = useQuery([scope, 'categories'], fetchCategoriesList);

  const {
    params: { category },
  } = useLocation();

  const categories = useMemo(() => {
    if (!data) {
      return [];
    }
    if (!category) {
      return fillCounts(filter(data.items, { parent: data.root_id }), data.items);
    }

    const catItem = find(data.items, { slug: category });
    if (!catItem) return [];

    return fillCounts(filter(data.items, { parent: catItem.term_id }), data.items);
  }, [data, category]);

  if (status === 'loading') {
    return (
      <Panel bordered>
        <Loader size="md" content="Loading..." />
      </Panel>
    );
  }

  if (status === 'error') {
    return <span>Error: {error.message}</span>;
  }

  return categories.length ? (
    <CategoriesWrap>
      <Categories categories={categories} />
    </CategoriesWrap>
  ) : (
    <CategoriesWrap>No Categories</CategoriesWrap>
  );
};
